// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  .mt-md-4-5 {
    margin-top: 1.9rem; /* between 24px (4) and 48px (5) */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/add-edit-party-information/add-edit-party-information.component.scss"],"names":[],"mappings":"AACI;EADJ;IAEM,kBAAA,EAAA,kCAAA;EACJ;AACF","sourcesContent":[".mt-md-4-5 {\r\n    @media (min-width: 768px) {\r\n      margin-top: 1.9rem; /* between 24px (4) and 48px (5) */\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
